export default __webpack_public_path__ + "static/media/restyling-kits.f542e1f8.mp4";